import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import RegisterData from '../../components/pages/register/Data';
import RegisterImages from '../../components/pages/register/Images';
import RegisterVideo from '../../components/pages/register/Video';
import Modal from '../../components/master/Modal';
import { getDirection } from '../../utils/functions';
import CleanCar from '../../assets/images/car.png';
import Lamp from '../../assets/images/ceiling-lamp.png';
import Camera360 from '../../assets/images/camera-360.png';
import SportCar from '../../assets/images/sport-car.png';

export default function Register({ history }) {

    const { t, i18n } = useTranslation();

    const [step, setStep] = useState(1);
    const [registerId, setRegisterId] = useState(null);
    const [carTypeId, setCarTypeId] = useState(null);
    const [openModal ,setOpenModal] = useState(true);
    function changeStep(step, data) {
        setStep(step);
        if (data) {
            setRegisterId(data.registerId);
            setCarTypeId(data.carTypeId)
        }
    }
    return (
        <div className='register content'>
            <Modal visible={openModal}>
                <div className="register-modal">
                    <div className={`modal-body mb20 ${getDirection(i18n.language) ==='rightToLeft'?' text-right': ' text-left'}`}>
                        <p className='modal-title mb10'>{t('Register modal title')}</p>

                        <div className={`d-flex align-items-center modal-item ${getDirection(i18n.language) === 'leftToRight' ? 'flex-row-reverse': ''}`}>
                            <p>{t('Register modal 1-clause')}</p>
                            <img src={CleanCar} alt="clean car"/>
                        </div>
                        <div className={`d-flex align-items-center modal-item ${getDirection(i18n.language) === 'leftToRight' ? 'flex-row-reverse': ''}`}>
                            <p>{t('Register modal 2-clause')} </p>
                            <img src={Lamp} alt="lamp"/>
                        </div>
                        <div className={`d-flex align-items-center modal-item ${getDirection(i18n.language) === 'leftToRight' ? 'flex-row-reverse': ''}`}>
                            <p>{t('Register modal 3-clause')}</p>
                            <img src={SportCar} alt="sport car"/>
                        </div>
                        <div className={`d-flex align-items-center modal-item ${getDirection(i18n.language) === 'leftToRight' ? 'flex-row-reverse': ''}`}>
                            <p>{t('Register modal 4-clause')}</p>
                            <img src={Camera360} alt="camera"/>
                        </div>
                    </div>
                <button className='btn btn-circle btn-green btn-block' onClick={()=>setOpenModal(false)}>{t('Get it')}</button>
                </div>
            </Modal>
            {
                step === 1 && <RegisterData changeStep={changeStep} />
            }
            {
                step === 2 &&
                <RegisterImages
                    changeStep={changeStep}
                    car_type_id={carTypeId}
                    register_id={registerId}
                    history={history}
                />
            }
            {
                step === 3 &&
                <RegisterVideo
                    registerId={registerId}
                />
            }
        </div>
    );

}
